export const environment = {
  postgrestBaseUrl: 'https://servreg.ivv.desp.space/api',
  fileSystemBaseUrl: 'https://servreg.ivv.desp.space/fs/serviceMedia',
  fileSystemMediaBaseUrl: 'https://servreg.ivv.desp.space/fs/generalMedia',
  fileSystemDocBaseUrl: 'https://servreg.ivv.desp.space/fs/docfiles',
  keycloakUrl: 'https://iam.ivv.desp.space/',
  realm: 'desp',
  clientId: 'srvregbe_public',
  enableLogging: true,
  logsUrl: 'https://servreg.ivv.desp.space/desp-servreg-logs'
};